import actionTypes from './index';

export default productList => ({ type: actionTypes.UPDATE_ELIGIBILITY, payload: { productList } });
